import { render } from "./AsaComponent.vue?vue&type=template&id=6822ae00"
import script from "./AsaComponent.vue?vue&type=script&lang=js"
export * from "./AsaComponent.vue?vue&type=script&lang=js"

import "./AsaComponent.vue?vue&type=style&index=0&id=6822ae00&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QTabPanel,QTabPanels,QBtn});
